<template>
  <div class="sidebar-container">
    <div class="logo" @click="handleLogoClick" :class="{ 'collapsed-logo': collapsed }">
      <img :src="logo" width="36" />
      <span v-if="!collapsed" class="logo-text">掌签智能化追溯管理系统</span>
    </div>

    <div class="menu-container">
      <a-menu theme="light" mode="inline" :selectedKeys="selectedKeys" :openKeys="defaultOpenKeys"
        :inline-collapsed="collapsed" :style="{ width: collapsed ? '80px' : '256px' }" @click="switchView"
        @openChange="openChange"
>
        <a-menu-item key="/home">
          <a-icon type="home" /><span>首页</span>
        </a-menu-item>

        <a-sub-menu v-for="menu in menus" :key="menu.key">
          <span slot="title">
            <a-icon :type="menu.icon" /><span>{{ menu.name }}</span></span>
          <a-menu-item v-for="submenu of menu.submenus" :key="submenu.key">{{ submenu.name }}</a-menu-item>
        </a-sub-menu>
      </a-menu>
    </div>
  </div>
</template>
<script>
import menus from '@/menus.js'

export default {
  name: 'Sidebar',
  props: ['collapsed'],
  data() {
    return {
      menus,
      openKeys: [],
      // 移除 selectedKeys: [], 从这里
      logo: require('@/assets/logo.png'),
      // wechatCustomerService: require('@/assets/wechat_customer_service.png'),
      // wechatExchange: require('@/assets/wechat_exchange.png'),
    };
  },
  computed: {
    selectedKeys() {
      const route = this.$route;
      const activeMenu = route.meta && route.meta.activeMenu;
      return [activeMenu || route.path];
    },
    // 添加一个计算属性来控制菜单的默认展开项
    defaultOpenKeys() {
      return this.collapsed ? [] : this.openKeys;
    }
  },
  watch: {
    $route(to) {
      this.changeRoute(to.path);
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    handleLogoClick() {
      this.$router.push('/');
      this.openKeys = []; // 清空所有打开的子菜单
      this.$emit('toggle-collapsed'); // 发送事件给父组件切换折叠状态

      // 强制关闭所有子菜单
      if (!this.collapsed) {
        // 如果当前是展开状态，先将所有子菜单关闭
        this.$nextTick(() => {
          this.openKeys = [];
        });
      }
    },
    initialize() {
      // 不再需要在这里设置selectedKeys，因为它现在是计算属性
      // 只需要设置openKeys
      this.updateOpenKeys(this.$route.path);
    },
    switchView(item) {
      if (this.$route.path !== item.key) {
        this.$router.push(item.key);
      }
    },
    openChange(openKeys) {
      // 确保只保留最后一个打开的菜单，如果openKeys为空则设置为空数组
      this.openKeys = openKeys.length > 0 ? [openKeys[openKeys.length - 1]] : [];
    },
    changeRoute(path) {
      // 移除 this.selectedKeys = [path]; 因为selectedKeys现在是计算属性
      this.updateOpenKeys(path);
    },
    updateOpenKeys(path) {
      for (let m of menus) {
        if (m.submenus.findIndex(item => item.key == path) != -1) {
          this.openKeys = [m.key];
          return;
        }
      }
    }
  },
}
</script>
<style scoped>
.sidebar-container {
  height: 100vh;
  position: fixed;
  /* 改为固定定位 */
  left: 0;
  top: 0;
  z-index: 999;
  width: 256px;
  /* 设置宽度 */
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  transition: width 0.3s;
}

/* 添加一个样式类用于折叠状态 */
.sidebar-container.collapsed {
  width: 80px;
}

.logo {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  height: 64px;
  display: flex;
  align-items: center;
  padding-left: 24px;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  transition: all 0.3s;
  width: 256px;
  overflow: hidden;
}

.collapsed-logo {
  width: 80px;
}

.logo img {
  margin-top: -6px;
}

.logo-text {
  color: #1890ff;
  margin-left: 6px;
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 添加菜单容器样式 */
.menu-container {
  padding-top: 64px;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
}

/* 确保菜单填充整个容器 */
:deep(.ant-menu) {
  flex: 1;
  border-right: none;
  overflow-x: hidden;
}

/* 调整菜单项的样式 */
:deep(.ant-menu-item),
:deep(.ant-menu-submenu-title) {
  margin: 0;
  padding-left: 24px !important;
}

/* 调整子菜单项的样式 */
:deep(.ant-menu-sub .ant-menu-item) {
  padding-left: 48px !important;
}
</style>